module.exports = __webpack_public_path__ + "img/CaretDown.907b7901.svg";